/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EntitySearchScope } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface GetMatchingPositionClassForSeasonPositionClassesParams {
  /** The unique id of the season to use to match a position class. */
  seasonId: string;
  orgSnapshotId?: string;
  orgCode?: string;
  jobCode?: string;
}

export interface GetMatchingPositionClassPositionClassesParams {
  orgId?: string;
  orgCode?: string;
  jobCode?: string;
}

export interface QueryFieldValuesPositionsParams {
  /** The name of the field to get values for. */
  fieldname: string;
}

@Injectable({
  providedIn: 'root'
})
export class PositionsService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Gets a position class using season data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMatchingPositionClassForSeasonPositionClasses(
    requestParameters?: GetMatchingPositionClassForSeasonPositionClassesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<number>;
  public getMatchingPositionClassForSeasonPositionClasses(
    requestParameters?: GetMatchingPositionClassForSeasonPositionClassesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<number>>;
  public getMatchingPositionClassForSeasonPositionClasses(
    requestParameters?: GetMatchingPositionClassForSeasonPositionClassesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<number>>;
  public getMatchingPositionClassForSeasonPositionClasses(
    requestParameters?: GetMatchingPositionClassForSeasonPositionClassesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getMatchingPositionClassForSeasonPositionClasses', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/position-classes/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgSnapshotId: requestParameters?.orgSnapshotId,
        OrgCode: requestParameters?.orgCode,
        JobCode: requestParameters?.jobCode
      }
    });
  }

  /**
   * Gets a position class.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMatchingPositionClassPositionClasses(
    requestParameters?: GetMatchingPositionClassPositionClassesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<number>;
  public getMatchingPositionClassPositionClasses(
    requestParameters?: GetMatchingPositionClassPositionClassesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<number>>;
  public getMatchingPositionClassPositionClasses(
    requestParameters?: GetMatchingPositionClassPositionClassesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<number>>;
  public getMatchingPositionClassPositionClasses(
    requestParameters?: GetMatchingPositionClassPositionClassesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/position-classes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgId: requestParameters?.orgId,
        OrgCode: requestParameters?.orgCode,
        JobCode: requestParameters?.jobCode
      }
    });
  }

  /**
   * Gets the positions search scope.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopePositions(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getScopePositions(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getScopePositions(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getScopePositions(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/positions/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets all fieldvalues for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesPositions(
    requestParameters?: QueryFieldValuesPositionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public queryFieldValuesPositions(
    requestParameters?: QueryFieldValuesPositionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValuesPositions(
    requestParameters?: QueryFieldValuesPositionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValuesPositions(
    requestParameters?: QueryFieldValuesPositionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldname = requestParameters?.fieldname;
    this.checkRequired('queryFieldValuesPositions', { fieldname });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/positions/field-values/${this.configuration.encodeParam({ name: 'fieldname', value: fieldname, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }
}
